<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h1>Our Privacy Policy</h1>

        <p>
            This privacy notice discloses the privacy practices for Handweaving.net. This privacy notice applies solely to information collected by this website. It will notify you of the following:
        </p>

        <ul>
            <li>What personally identifiable information is collected from you through the website, how it is used and with whom it may be shared.</li>
            <li>What choices are available to you regarding the use of your data.</li>
            <li>The security procedures in place to protect the misuse of your information.</li>
            <li>How you can correct any inaccuracies in the information.</li>
        </ul>

        <h2>Information Collection, Use, and Sharing</h2>

        <p>
            We are the sole owners of the information collected on this site. We only have access to information that you voluntarily give us via email or other direct contact from you such as site registration. We will not sell or rent this information to anyone without your consent.
        </p>

        <p>
            We will use your information to respond to you, regarding the reason you contacted us, and to facilitate login and access to Handweaving.net. We will not share your information with any third party outside of our organization without your consent, other than as necessary to fulfill your request, e.g. to ship an order.
        </p>

        <p>
            We may contact you via email in the future to tell you about specials, new products or services, changes to this privacy policy, or other matters related to Handweaving.net. Generally we only send individual responses to email queries and messages to those who have voluntarily signed up for our mailing list.
        </p>

        <h2>Your Access to and Control Over Information</h2>

        <p>
            You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via our
            <router-link to='/contact'>contact link</router-link>:
        </p>

        <ul>
            <li>See what data we have about you, if any.</li>
            <li>Change/correct any data we have about you.</li>
            <li>Have us delete any data we have about you.</li>
            <li>Express any concern you have about our use of your data.</li>
        </ul>

        <h2>Security</h2>

        <p>
            We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.
        </p>

        <p>
            Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted in a secure way. You can verify this by looking for a lock icon in the address bar and looking for "https" at the beginning of the address of the Web page. Credit card and other financial data is transmitted directly from you to our subscription service provider, PayPal Braintree, and is never present or stored on Handweaving.net itself.
        </p>

        <p>
            While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computers/servers in which we store personally identifiable information are kept in a secure environment.
        </p>

        <p>
            If you feel that we are not abiding by this privacy policy, you should contact us immediately via email at customerservice(at)handweaving.net, or by using the
            <router-link to='/contact'>contact link</router-link> on our site.
            <p>

                <h2>Registration</h2>

                <p>
                    In order to use portions of this website, you must first complete the registration form. During registration you are required to give certain information (such as name, email address, and a password for site login). This information is used to allow you to log in to our site to provide access to personalized features such as the draft clipboard, and to verify your identity to gain access to subscription features.
                </p>

                <h2>Orders</h2>

                <p>
                    For store.handweaving.net online draft collection and CD orders, we use Shopify as an external e-commerce partner. To buy from us through Shopify, you must provide contact information (like name and shipping address) and financial information (like credit card number, expiration date). This information is used for billing purposes and to fill your orders. If we have trouble processing an order, we'll use this information to contact you. Collection, storage, and use of this information happens entirely through Shopify and is governed by Shopify's own separate privacy policy.
                </p>

                <h2>Cookies and Web Local Storage</h2>

                <p>
                    We may use "cookies" and other local persistence mechanisms such as html5 local storage on this site. Cookies and web local storage hold a piece of data stored on a site visitor's hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie or web local storage to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies and/or web local storage do not directly contain any personally identifiable information about you, but our site uses them to identify your account.
                </p>

                <p>
                    Our site contains widgets and links to external business partners such as Shopify, Facebook, Google, and Pinterest. External partners may use their own cookies on our site, however we have no access to or control over these cookies.
                </p>

                <h2>Remote Data Storage and Tracking</h2>

                <p>
                    We record site logins, drafts, and digital documents access on a per-user basis, both by IP address and on an individual account level, in a personally identifiable way for logged in users. This information is not shared with others and is used for analyzing site and material usage and traffic patterns to identify trouble with portions of the website whether or not reported, and to help avoid misuse of the site such as through denial of service attacks.
                </p>

                <h2>Sharing</h2>

                <p>
                    We share aggregated site usage information with analytics provider, Google Analytics. This is not linked to any information that can identify any individual person and we use it for assessing usage patterns and visitor flows to inform future improvements to the site.
                </p>

                <p>
                    We use outside credit card processing companies (Shopify and PayPal Braintree) to bill users for goods and services. These companies do not retain, share, store or use personally identifiable information for any secondary purposes beyond filling your orders.
                </p>

                <h2>Links and Embedded Widgets</h2>

                <p>
                    This website contains links to and embedded widgets for other sites such as Facebook, Pinterest, and others. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.
                </p>

                <h2>Tags, Likes, and Other Social Data</h2>

                <p>
                    This website contains user-entered draft tags, "likes", and other social data.  We will show this specific data as public to all users of the site and may remove or change this data at any time. 
                    Tags and other such data which you enter expected to be related to weaving topics, to contain no profanity, and to suitable for a general audience.
                </p>

                <h2>Surveys</h2>

                <p>
                    From time-to-time our site may request information via surveys or contests. Participation in these surveys completely voluntary and you may choose whether or not to participate and therefore disclose this information. Information requested may include contact information (such as name and shipping address), and demographic information (such as zip code, age level). Survey information will be used for purposes of monitoring or improving the use and satisfaction of this site.
                </p>

                <h2>Privacy Policy Updates</h2>

                <p>
                    From time to time, we may amend this privacy policy on our site without other notice.
                </p>

    </b-container>
</template>

<script>
export default {
    created() {
        this.$store.commit('setPageTitle', 'Privacy Policy')
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue